module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/eeacc9d960d531d5a3066cc74fb41647.jpg";